// extracted by mini-css-extract-plugin
export default {"container":"talksport_container__CR01F"};